import { authFetch } from "../utils/AuthFetch";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api';

export const getUserDetails = async () => {
    const token = localStorage.getItem('user_token');
    const response = await authFetch(`${API_BASE_URL}/user/details`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
  
    if (!response.ok) {
      throw new Error('사용자 정보를 불러오는 데 실패했습니다.');
    }
  
    return response.json();
  };

export const updateUserDetails = async (userData: { nickname?: string; phone?: string }) => {
    const token = localStorage.getItem('user_token');
    const response = await authFetch(`${API_BASE_URL}/user/update`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(userData),
    });
  
    if (!response.ok) {
      throw new Error('사용자 정보 업데이트에 실패했습니다.');
    }
  
    return response.json();
  };

export const deleteAccount = async () => {
    const token = localStorage.getItem('user_token');
    const response = await authFetch(`${API_BASE_URL}/user/delete`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
  
    if (!response.ok) {
      throw new Error('계정 삭제에 실패했습니다.');
    }
  
    return response.json();
  };

export const addFavorite = async (spaceId: number) => {
    const token = localStorage.getItem('user_token');
    const response = await authFetch(`${API_BASE_URL}/user/favorites/${spaceId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
  
    if (!response.ok) {
      throw new Error('관심공간 등록에 실패했습니다.');
    }
  
    return response.json();
  };

export const removeFavorite = async (spaceId: number) => {
    const token = localStorage.getItem('user_token');
    const response = await authFetch(`${API_BASE_URL}/user/favorites/${spaceId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
  
    if (!response.ok) {
      throw new Error('관심공간 해제에 실패했습니다.');
    }
  
    return response.json();
  };

export const getFavorites = async () => {
    const token = localStorage.getItem('user_token');
    const response = await authFetch(`${API_BASE_URL}/user/favorites`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
  
    if (!response.ok) {
      throw new Error('관심공간 목록을 불러오는데 실패했습니다.');
    }
  
    return response.json();
  };

export async function registerUserAccount({ bank_code, account_number, account_holder_name }: 
  { bank_code: string, account_number: string, account_holder_name: string }) {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api';
  const token = localStorage.getItem('user_token');

  const res = await authFetch(`${API_BASE_URL}/user/accounts`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ bank_code, account_number, account_holder_name }),
  });

  if (!res.ok) throw new Error(await res.text());
  return await res.json();
}

export async function fetchBankCodes() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api';
  const res = await fetch(`${API_BASE_URL}/user/bank_codes`);
  if (!res.ok) throw new Error('은행 리스트 조회 실패');
  const data = await res.json();
  return data.body || [];
}

export async function getUserAccountByAdmin(userId: number) {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api';
  const token = localStorage.getItem('user_token');
  const res = await fetch(
    `${API_BASE_URL}/user/accounts/${userId}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    }
  );
  if (!res.ok) throw new Error('계좌 정보 조회 실패');
  const data = await res.json();
  return data.body;
}